import React, {Component} from "react";
import theplunge from "../../assets/img/theplunge.png";
import cyantag from "../../assets/img/cyan-price-tag-round@2x.png";
import image27 from "../../assets/img/new-2.png";
import {PLUNGE_1, PLUNGE_2, POWDER_LABEL} from "../../consts/copy";
import powder from "../../assets/img/Powder.png";
import mintbreak from "../../assets/img/mint-break.png";
import {Link} from "react-router-dom";


class Plunge extends Component {
    render() {
        return (
            <>
                <section className='col-ac text-center bg-mint pt-100 pb-100 relative'>
                    <div className='pt-80'>
                        <img src={theplunge} style={{width: 550}}/>
                    </div>
                    <div className={this.props.tablet ? 'w-60p relative' : 'w-40p relative'} style={{zIndex: 1}}>
                        <div className='absolute' style={{top: -520, right: -400}}>
                            <div className='relative col-ac' style={{zIndex: 12}}>
                                <img src={cyantag} style={{marginBottom: -80, width: 120, zIndex: 999}}/>
                                <img src={image27} style={{width: 310}}/>
                            </div>
                        </div>
                        <div className='font-2'>
                            <div className='mt-80 mb-64'>
                                <p className='bold mb-24'>
                                    {PLUNGE_1}
                                </p>
                                <p className='bold'>
                                    {PLUNGE_2}
                                </p>
                                <Link to='/theplunge' style={{textDecoration: 'none', fontSize: 36}}>
                                    <button className='font-3 mt-32'>
                                        Take the Plunge
                                    </button>
                                </Link>
                            </div>
                            <img src={powder} style={{width: 425}}/>
                            <p className='mt-24 bold font-3'>
                                {POWDER_LABEL}
                            </p>
                        </div>
                    </div>
                </section>
                <div className='relative w-100p'>
                    <div className='page-break1'>
                        <img src={mintbreak} className='w-100p'/>
                    </div>
                </div>
            </>
        )
    }
}

export default Plunge
